// src/App.js
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import History from './pages/History';
import Contact from './pages/Contact';
import Shop from './pages/Shop';
import ProductPage from './pages/ProductPage';
import LandingPage from './pages/LandingPage';
import CartWidget from './components/CartWidget';
import { CartProvider } from './CartContext';
import { ToastContainer } from 'react-toastify';
import Login from './pages/Login';
import Wallet from './pages/Wallet';
import ReleaseProduct from './pages/ReleaseProduct';
import Checkout from './pages/Checkout';
import Signup from './pages/Signup';
import OrderConfirmation from './pages/OrderConfirmation';
import MyOrders from './pages/MyOrders';
import PrivacyPolicy from './pages/PrivacyPolicy';
import 'react-toastify/dist/ReactToastify.css';


function App() {
  const location = useLocation();



  return (
    <CartProvider>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/history" element={<History />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route path="/contact" element={<Contact />} />
                <Route path="/order-confirmation" element={<OrderConfirmation />} />
                        <Route path="/my-orders" element={<MyOrders />} />
                                                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/login" element={<Login />} />
                        <Route path="/wallet" element={<Wallet />} />
                        <Route path="/release" element={<ReleaseProduct />} />
                        <Route path="/checkout" element={<Checkout />} />
                                <Route path="/signup" element={<Signup />} />
      </Routes>
      <CartWidget />
      <ToastContainer 
        position="top-center"
        autoClose={1800}
        hideProgressBar
        theme="dark"
      />
    </CartProvider>
  );
}

export default App;
